import React from "react";
import { Download, FileText } from "lucide-react";
import { downloadFile } from "../../lib/downloadFile";

function formatSize(bytes) {
  if (!bytes) return "";
  const units = ["B", "KB", "MB", "GB"];
  let i = 0;
  let n = bytes;
  while (n >= 1024 && i < units.length - 1) {
    n /= 1024;
    i++;
  }
  return `${n.toFixed(n < 10 ? 1 : 0)} ${units[i]}`;
}

export default function FileLink({ src, name, size }) {
  return (
    <button
      type="button"
      onClick={() => downloadFile(src, name)}
      data-testid="file-download-btn"
      className="w-full text-left flex items-center gap-3 bg-[#161a2c] border border-white/5 rounded-xl p-3 hover:border-paul-yellow/50 transition-colors group"
      title="Download"
    >
      <div className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-paul-yellow flex-shrink-0">
        <FileText className="w-5 h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm text-white truncate font-medium">{name}</div>
        <div className="text-xs text-white/40">{formatSize(size)}</div>
      </div>
      <Download className="w-4 h-4 text-white/40 group-hover:text-paul-yellow flex-shrink-0" />
    </button>
  );
}
